import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Lottie } from "../../constant/lottie";
import { GtmService } from "../../services/gtm-service/gtm.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { dialogContent } from "../../constant/content";

@Component({
    selector: "web-info-dialog",
    templateUrl: "./info-dialog.component.html",
    styleUrls: ["./info-dialog.component.scss"],
})
export class InfoDialogComponent {
    content: any;
    lottie: any;
    private popupName: string = "confirmation_dialog";
    contentDescription!: SafeHtml;

    constructor(
        public lotties: Lottie,
        private gtmService: GtmService,
        public dialogRef: MatDialogRef<InfoDialogComponent>,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.lottie = this.lotties;

        // Check if object passed or just key
        if (data?.content && typeof data.content === "object") {
            this.content = { ...data.content };
        } else {
            this.content = dialogContent[data?.content] || {};
        }
    }

    ngOnInit(): void {
        // Track popup opened
        this.gtmService.trackPopupOpened(this.popupName, {
            popup_content: this.data?.content || "confirmation",
            popup_title: this.content?.title || null,
            popup_trigger: "user_action",
        });

        if (this.content?.html && this.content?.description) {
            this.contentDescription = this.sanitizer.bypassSecurityTrustHtml(this.content.description);
        }
    }

    onConfirmClick(): void {
        // Track popup closed with confirm action
        this.gtmService.trackPopupClosed(this.popupName, {
            close_reason: "user_action",
            interaction_type: "confirm",
        });

        this.dialogRef.close({ confirmed: true, data: this.data });
    }

    closeDialog() {
        this.dialogRef.close({
            success: false,
        });
    }
}
